import { collectionsConfig, config } from 'lib/config'
import { delay, map, Observable } from 'rxjs'
import { ajax } from 'rxjs/ajax'

export interface Response {
  count: number
  data: Data
  pageToken?: string
  startIndex?: number
  total: number
}

export type Data = DataItem[]

export interface DataItem {
  total: number
  allowedMemberTypes: string[]
  application: string
  createdTime: string
  creatorId: string
  deleteAccess: string
  deleted: boolean
  description: string
  id: string
  instanceVersion: string
  name: string
  portraitImageUrl: string
  readAccess: string
  sor: string
  type: string
  updatedTime: string
  viewCount: number
  writeAccess: string
}

export interface CollectionFormPayload {
  description?: string
  name: string
  id: string
  portraitImageUrl?: string
  type: string
}

export const httpGetCollections = (
  accessToken: string,
  creatorId: string,
  pageToken?: string,
  deleted = false,
  count = collectionsConfig.collectionPageSize
): Observable<Response> => {
  const url = new URL(`${config.SCBE_URL}/scbe/v20/collection`)
  url.searchParams.set('q', `creatorId=${creatorId}`)
  url.searchParams.set('count', `${count}`)
  if (pageToken !== undefined) {
    url.searchParams.set('pageToken', `${pageToken}`)
  }

  if (deleted !== undefined) {
    url.searchParams.set('deleted', Boolean(deleted).toString())
  }

  return ajax({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: 'GET',
    url: url.pathname + url.search,
  }).pipe(
    delay(collectionsConfig.collectionsRequestDelay),
    map((ajax) => ajax.response as Response)
  )
}

export const httpCreateCollection = (
  accessToken: string,
  creatorId: string,
  collection: CollectionFormPayload
): Observable<DataItem> => {
  const url = new URL(`${config.SCBE_URL}/scbe/v20/collection`)
  url.searchParams.set('q', `creatorId=${creatorId}`)

  return ajax({
    body: collection,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: 'POST',
    url: url.pathname + url.search,
  }).pipe(
    delay(collectionsConfig.collectionsRequestDelay),
    map((ajax) => ajax.response as DataItem)
  )
}

export const httpEditCollection = (
  accessToken: string,
  creatorId: string,
  collection: CollectionFormPayload
): Observable<DataItem> => {
  const url = new URL(`${config.SCBE_URL}/scbe/v20/collection/${collection.id}`)
  url.searchParams.set('q', `creatorId=${creatorId}`)

  return ajax({
    body: collection,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: 'PUT',
    url: url.pathname + url.search,
  }).pipe(
    delay(collectionsConfig.collectionsRequestDelay),
    map((ajax) => ajax.response as DataItem)
  )
}

export const httpDeleteCollection = (
  accessToken: string,
  creatorId: string,
  collectionId: string
): Observable<void> => {
  const url = new URL(`${config.SCBE_URL}/scbe/v20/collection/${collectionId}`)
  url.searchParams.set('q', `creatorId=${creatorId}`)

  return ajax({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: 'DELETE',
    url: url.pathname + url.search,
  }).pipe(
    map((_) => {
      return
    })
  )
}
